import React, { useState } from 'react'
import { Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import MiniProjectInfo from '../../projectBasedItemsWidget/MiniProjectInfo'
import AddAssetCountingTable from './AddAssetCountingTable'

export default function AddAssetCountingWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [formSchema, setFormSchema] = useState(props.schema)

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={formSchema.header} bordered>
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        <AddAssetCountingTable
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          schema={formSchema?.form}
          isViewMode={!formSchema?.form?.isEnableEdit}
          isSupplyOfficer={false}
          disabled={formSchema?.disabled}
        />
      </Panel>
    </>
  )
}
